export default "__VITE_ASSET__BNM_MprS__"